import { render, staticRenderFns } from "./choose-standard-printer.vue?vue&type=template&id=20dc6474"
import script from "./choose-standard-printer.vue?vue&type=script&lang=js"
export * from "./choose-standard-printer.vue?vue&type=script&lang=js"
import style0 from "./choose-standard-printer.vue?vue&type=style&index=0&id=20dc6474&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports